<template>
  <v-row class="d-flex justify-center">
    <v-col cols="12" lg="10" md="10">
      <add-edit-mailbox-provider-form
        :is-content-loading="isLoading"
        @update-provider-name="setProviderName"
        :mailbox-provider-details="mailboxProvider"
      />
    </v-col>
  </v-row>
</template>

<script>
import AddEditMailboxProviderForm from "@/components/forms/AddEditMailboxProviderForm.vue";

/**
 * Mailbox provider profile
 */
export default {
  name: "MailboxProviderProfile",
  /**
  |--------------------------------------------------
  | Custom events
  |--------------------------------------------------
  */
  emits: ["set-provider-name"],
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    AddEditMailboxProviderForm,
  },
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    mailboxProvider: { type: Object, required: true, default: () => ({}) },
    isLoading: { type: Boolean, required: true, default: false },
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    /**
     * @emits set-provider-name event in parent component with mailbox provider name
     */
    setProviderName(data) {
      this.$emit("set-provider-name", data?.name ?? "");
    },
  },
};
</script>
